import { IIconProps } from './add';

export const IcoDownloadPDF: React.FC<IIconProps> = ({ style, cy }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    data-cy={`IcoDownloadPDF${cy}`}
  >
    <path
      d="M8 0.5C3.8675 0.5 0.5 3.8675 0.5 8C0.5 12.1325 3.8675 15.5 8 15.5C12.1325 15.5 15.5 12.1325 15.5 8C15.5 3.8675 12.1325 0.5 8 0.5ZM8 14C4.6925 14 2 11.3075 2 8C2 4.6925 4.6925 2 8 2C11.3075 2 14 4.6925 14 8C14 11.3075 11.3075 14 8 14ZM9.9425 5.4425L11 6.5L8 9.5L5 6.5L6.0575 5.4425L7.25 6.6275V3.5H8.75V6.6275L9.9425 5.4425ZM11.75 11.75H4.25V10.25H11.75V11.75Z"
      fill="#525A66"
    />
  </svg>
);
